import { useCurrentStateAndParams } from "@uirouter/react";
import { useSelector } from "react-redux";
import type { RootState } from "single-spa/store/types";
import { selectListById } from "../store/selectors";
import type { OpportunityListType } from "../types";

export default function useCurrentStaticList(): Readonly<OpportunityListType> | undefined {
    const { params } = useCurrentStateAndParams();

    return useSelector((s: RootState) => selectListById(s, params.id));
}
